<li
  *ngFor="let item of items(); trackBy: trackByKey"
  class="location-item d-flex flex-column p-0"
  [class.location-item-active]="isActive(item)"
  [ngClass]="'location-item-type-' + item.data.type"
>
  <!-- ── Row ──────────────────────────────────────────────────────────── -->
  <div
    [attr.data-automation-id]="item.data.name"
    class="hierarchy-item-row d-flex align-items-center w-100 list-group-item list-group-item-hover border-0"
    [class.active]="isIncluded(item)"
    [style.padding-left.px]="8 + level() * 20"
    (click)="toggle(item, $event)"
  >
    <!-- Chevron (expand/collapse) -->
    <i
      *ngIf="item.children"
      class="f-i f-i-sm hierarchy-chevron flex-shrink-0 me-1"
      [class.f-i-chevron-right]="item.isCollapsed"
      [class.f-i-chevron-down]="!item.isCollapsed"
    ></i>
    <span *ngIf="!item.children" class="hierarchy-chevron-placeholder flex-shrink-0 me-1"></span>

    <!-- Location name -->
    <span class="hierarchy-item-text flex-grow-1 text-truncate me-2">{{ item.data.name }}</span>

    <!-- Include / Exclude links -->
    <div class="d-flex gap-2 flex-shrink-0">
      <a
        class="link-danger location-item-button-exclude"
        [class.fw-bold]="isExcluded(item)"
        (click)="onSelect(item, SelectionType.Exclude, $event)"
        >{{ isExcluded(item) ? excludedText() : excludeText() }}</a
      >
      <a
        class="link-primary location-item-button-include"
        [class.fw-bold]="isIncluded(item)"
        (click)="onSelect(item, SelectionType.Include, $event)"
        >{{ isIncluded(item) ? includedText() : includeText() }}</a
      >
    </div>
  </div>

  <!-- ── Children — lazy render on first expand ────────────────────────── -->
  <div *ngIf="item.children && !item.isCollapsed" class="hierarchy-expand-container">
    <ul class="list-unstyled mb-0">
      <f-location-hierarchy-item
        [items]="item.children"
        [level]="level() + 1"
        [selectedItems]="selectedItems()"
        [excludeText]="excludeText()"
        [excludedText]="excludedText()"
        [includeText]="includeText()"
        [includedText]="includedText()"
        (itemSelect)="onChildSelect($event)"
        (itemToggle)="onChildToggle($event)"
      ></f-location-hierarchy-item>
    </ul>
  </div>
</li>
